import FlightDetail from './FlightDetail';
export default FlightDetail;
